import React, {useState, useEffect, useRef } from "react";
import { Box, Button } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import "../../../../assets/styles/audio-question.css";
import { ResourceLinks } from "../../../../constants";
import { useSelector } from "../../../../store";

export default function WebMultipleChoiceObjectAudio({ question, onAnswer = () => {} }) {
    const theme = useTheme();
    const questionData = question;
    const learnerState = useSelector((state) => state.learner || {});
    const data = learnerState?.details?.testLevel === "vfh" ? questionData?.vfh : questionData?.acsf4;
    const imagesResources = ResourceLinks.llnQuizImage;
    const audioResources = ResourceLinks.audio;

    const [selectedChoices, setSelectedChoices] = useState({});

    // for audio header
    const [audioInfo, setAudioInfo] = useState(data.audioInfo);
    const [playingAudioUrl, setPlayingAudioUrl] = useState("");
    const [imageSrc, setImageSrc] = useState(data?.image);
    const [questionList, setQuestionList] = useState(data?.questionList || []);
    const refs = useRef({});

    // every time question change we will set to reset needed to reset
    useEffect(() => {
        setSelectedChoices({});
        setAudioInfo(data.audioInfo);
        setPlayingAudioUrl("");
        setImageSrc(data?.image);
        setQuestionList(data?.questionList || [])
    }, [question,
        data.audioInfo,
        data?.image,
        data?.questionList,
    ]);

    const handleChoiceClick = (columnIndex, choice) => {
        const newSelectedChoices = {
            ...selectedChoices,
            [columnIndex]: choice,
        };
        setSelectedChoices(newSelectedChoices);

        let canProceed = false;
        const answerKeys = questionData?.answerKeys || [];
        const answerValue = answerKeys.reduce((acc, key, index) => {
            acc[key] = newSelectedChoices[index] || "";
            if (acc[key] !== "" && acc[key] !== null) {
                canProceed = true;
            }
            return acc;
        }, {});

        onAnswer({
            canProceed,
            answer: answerValue,
        });
    };

    // Hardcoded button styles
    const selectedStyles = {
        backgroundColor: "rgba(255, 217, 102, 0.75)",
        border: "2px solid rgb(255, 192, 0)",
        borderWidth: "1px",
    };

    const defaultStyles = {
        backgroundColor: "transparent",
        border: "transparent",
        borderWidth: "1px",
    };

    const playAudio = (url) => {

        const previousUrl = playingAudioUrl;
        if (playingAudioUrl !== "") {
                // we will control the play or pause
            if (refs.current[previousUrl]) {
                refs.current[previousUrl].pause();
                setPlayingAudioUrl("");
            } else {
                // set url
                setPlayingAudioUrl(url);
                refs.current[url].play();
            }
        } else {
            // set url
            setPlayingAudioUrl(url);
            refs.current[url].play();
        }
    }

    const handleEnded = () => {
        setPlayingAudioUrl("");
    }

    return (
        <React.Fragment>
            <Box
                sx={{
                    display: "flex",
                    justifyContent: "center",
                    backgroundColor: "white",
                    flexDirection: "column",
                    p: 2,
                }}
            >
                
                <Box sx={{
                    marginBottom: "20px",
                }}>
                    <Button
                        sx={{
                            position: "relative",
                            outline: "none",
                            border: "none",
                            cursor: "pointer",
                            backgroundColor: "hsl(204,100%,47%)",
                            borderBottom: "5px solid hsl(204,100%,37%)",
                            borderRadius: "5px",
                            minWidth: "15em",
                            minHeight: "3em",
                            fontWeight: "bold",
                            textAlign: "left",
                            justifyContent: "left",
                            paddingLeft: "35px",
                            margin: "5px",
                            marginLeft: "15px",
                            color: "black",
                            "&:hover": {
                                    backgroundColor: "hsl(204,100%,44%)",
                                    borderBottomColor: "hsl(204,100%,34%)",
                                },
                            fontSize: "18px",
                        }}
                        onClick={() => playAudio(audioInfo.audioSrc)}
                    >{audioInfo.value}
                        <Box component="img" 
                            src={playingAudioUrl === "" ? "data:image/png;base64,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"
                                : "data:image/png;base64,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"}
                            sx={{
                                position: "absolute",
                                left: "-14px",
                                top: "-2.5px",
                                cursor: "pointer",
                                fontWeight: "bold",
                                textAlign: "left",
                            }}
                            alt="Play Icon Img"
                        />
                        <audio ref={(el) => refs.current[audioInfo.audioSrc] = el} src={`${audioResources}${audioInfo.audioSrc}`} onEnded={handleEnded}/>
                    </Button>
                </Box>

                {imageSrc && (
                    <Box
                        sx={{
                            display: "flex",
                            justifyContent: "center",
                            alignSelf: "center",
                            position: "relative",
                            mb: 4,
                            width: "100%",
                            maxWidth: "850px",
                        }}
                    >
                        <Box component="img"
                            src={`${imagesResources}${imageSrc}`}
                            alt="Question"
                            sx={{ width: "100%", height: "auto" }}
                        />

                        {questionList.map((column, columnIndex) => {
                            const leftPos = column?.positions?.leftPos || 0;
                            const width = column?.positions?.width || "30%";
                            const height = column?.positions?.height || "25%";

                            return column.choices.map((choice, choiceIndex) => {
                                const topPos =
                                    column?.positions?.topPos?.[choiceIndex] ||
                                    0;

                                const isSelected =
                                    selectedChoices[columnIndex] === choice;

                                return (
                                    <Button
                                        key={`${columnIndex}-${choiceIndex}`}
                                        variant={
                                            isSelected
                                                ? "contained"
                                                : "outlined"
                                        }
                                        onClick={() =>
                                            handleChoiceClick(
                                                columnIndex,
                                                choice
                                            )
                                        }
                                        sx={{
                                            position: "absolute",
                                            top: `${topPos}%`,
                                            left: `${leftPos}%`,
                                            width: width,
                                            height: height,
                                            minWidth: "50px",
                                            backgroundColor: isSelected
                                                ? selectedStyles.backgroundColor
                                                : defaultStyles.backgroundColor,
                                            color: isSelected
                                                ? "white"
                                                : theme.palette.primary.main,
                                            border: isSelected
                                                ? selectedStyles.border
                                                : defaultStyles.border,
                                            "&:hover": {
                                                backgroundColor: isSelected
                                                    ? selectedStyles.backgroundColor
                                                    : defaultStyles.backgroundColor,
                                                border: isSelected
                                                    ? selectedStyles.border
                                                    : defaultStyles.border,
                                            },
                                        }}
                                    />
                                );
                            });
                        })}
                    </Box>
                )}
            </Box>
        </React.Fragment>
    );
}
